<template>
  <Modal :open="newAppVersionAvailable" heading="New content available" content="New content is available; please reload the app to continue." @closeModal="reloadApp">
    <Button type="button" @click.native="reloadApp" title="Reload the app">
    </Button>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from './Modal.vue'
import Button from '@/components/partials/Button.vue'

export default {
  components: {
    Modal,
    Button
  },
  computed: {
    ...mapState({
      newAppVersionAvailable: state => state.newAppVersionAvailable,
    })
  },
  methods: {
    reloadApp () {
      window.destination.reload(true)
    }
  }
}
</script>
